export const environment = {
    production: false,
    favicon: 'green' as 'blue' | 'green' | 'pink' | 'purple' | 'yellow',
    serverUrl: '/api',
    googleMapsApiKey: 'AIzaSyDBzhRRfFRhE9YURG7XMTpPl1P10dtD6-M',
    firebaseConfig: {
        apiKey: "AIzaSyC2-dzR35MxPlEXZa-p0B2q-imj--6ZqtM",
        authDomain: "bfor-scan-6f78e.firebaseapp.com",
        projectId: "bfor-scan-6f78e",
        storageBucket: "bfor-scan-6f78e.firebasestorage.app",
        messagingSenderId: "239677059771",
        appId: "1:239677059771:web:e04296572b29ae14512f9e",
        measurementId: "G-BCW5608SB3"
    },
    vapidKey: 'BMIAGwxBQumdBVihruA4a4qliuqQ_xcvNlxNZNQSWMbi33jfJTW3oK25ACk5eG9567-1VqRoGaL4ffTBpF07OEs'
};
